const MicroCache = require('./MicroCache')

const latin1symbols =
  '\n\rΔΓΛΩΠΨΣΘΞ\x1B!"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ '
const latin1symbolsOnlyRegExp = /^[\n\rΔΓΛΩΠΨΣΘΞ\x1B!"#$%&'()*+,-.\/0-9:;<=>?@A-z[\]^_`{|}~€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ ]*$/
exports.latin1symbols = latin1symbols
exports.latin1symbolsOnlyRegExp = latin1symbolsOnlyRegExp

const ASCIISymbols =
  '\n\rΔΓΛΩΠΨΣΘΞ\x1B!"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~DÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´¬±‗¾¶§÷¸°¨•¹³²■n '
const ASCIISymbolsOnlyRegExp = /^[\n\rΔΓΛΩΠΨΣΘΞ\x1B!"#$%&'()*+,-.\/0-9:;<=>?@A-z[\]^_`{|}~DÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´¬±‗¾¶§÷¸°¨•¹³²■n ]*$/
exports.ASCIISymbols = ASCIISymbols
exports.ASCIISymbolsOnlyRegExp = ASCIISymbolsOnlyRegExp

const STABLE_ASCIISymbols =
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\x1BÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'
const STABLE_ASCIISymbolsOnlyRegExp = /^[@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\x1BÆæßÉ !"#¤%&\'()*+,\-./0-9:;<=>?¡A-ZÄÖÑÜ§¿a-zäöñüà\f^{}\\[~\]|€]*$/
exports.STABLE_ASCIISymbols = STABLE_ASCIISymbols
exports.STABLE_ASCIISymbolsOnlyRegExp = STABLE_ASCIISymbolsOnlyRegExp

const smsStatsCache = new MicroCache({
  renewOnGet: true
})

const calculateSmsStats = text => {
  text = '' + (text || '')

  if (smsStatsCache.has(text)) {
    return smsStatsCache.get(text)
  }

  const characters = text.length
  const rules = {
    ascii: [
      {
        from: 160,
        count: 1
      },
      {
        from: 306,
        count: 2
      }
    ],
    unicode: [
      {
        from: 70,
        count: 1
      },
      {
        from: 134,
        count: 2
      }
    ]
  }

  let currentEncoding = 'ascii'
  if (!STABLE_ASCIISymbolsOnlyRegExp.test(text)) {
    // eslint-disable-line
    currentEncoding = 'unicode'
  }

  let segmentsCount = 0,
      segmentLength = 0,
      rule = rules[currentEncoding]

  rule.some(o => {
    segmentLength = o.from
    if (o.from >= characters) {
      segmentsCount = o.count

      return true
    }
  })

  if (segmentsCount === 0) {
    segmentsCount = 2
    switch (currentEncoding) {
      case 'ascii':
      case 'e7bit':
        segmentsCount += Math.ceil((characters - segmentLength) / 153)
        break
      default:
        segmentsCount += Math.ceil((characters - segmentLength) / 67)
        break
    }
  }

  const result = {
    segments: segmentsCount || 1,
    characters
  }

  smsStatsCache.set(text, result)

  return result
}
const calculateVoiceStats = text => {
  text = '' + text || ''

  const characters = text.length
  const segmentLength = 70

  const result = {
    segments: Math.ceil(characters / segmentLength) || 1,
    characters
  }

  return result
}
exports.calculateSmsStats = calculateSmsStats
exports.calculateVoiceStats = calculateVoiceStats

const { PhoneNumberUtils } = require('@sigmasms/commons')

function parseAndConvertPhoneNumber(phoneNumber = '', convertTo = 'e164') {
  return PhoneNumberUtils.parseAndConvertPhoneNumber(phoneNumber, convertTo)
}
exports.parseAndConvertPhoneNumber = parseAndConvertPhoneNumber
